<button mat-menu-item (click)="preview()">
  <span>{{ 'Contacts.List.preview' | translate }}</span>
</button>

<button mat-menu-item (click)="edit()">
  <span>{{ 'Contacts.List.edit' | translate }}</span>
</button>

<button mat-menu-item (click)="addSubcontact()">
  <span>{{ 'Contacts.List.addSubcontact' | translate }}</span>
</button>

@if (!_row?.deleted) {
  <button *appHasRole="AppRole.ADMIN" mat-menu-item class="hover_red red-500" (click)="remove()">
    <span>{{ 'Contacts.List.remove' | translate }}</span>
  </button>
}
